import { render, staticRenderFns } from "./DeliveryTypes.vue?vue&type=template&id=04290739&"
import script from "./DeliveryTypes.vue?vue&type=script&lang=js&"
export * from "./DeliveryTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports